import { Logo } from '@/components/logo';
import { Box, Flex, Text } from '@mantine/core';
import { SignupImage } from './signup-image';
import { SplashBottom } from './splash-bottom';
import styles from './styles.module.css';

export const SignupHeader = () => {
	return (
		<Flex
			h="279px"
			align="flex-start"
			justify="flex-start"
			w="100%"
			direction="column"
			className={styles.top}
		>
			<Flex w="100%" h="100%" justify="start-end" p="lg">
				<Flex direction="column" h="95%">
					<Logo />
					<Box h="20px" />
					<Text c="white" fw={700} fz="22px" w="166px">
						Recycle with Curby and have a chance to win!
					</Text>
					<Text fw="900" size="xl">
						Sign Up
					</Text>
				</Flex>
				<SignupImage />
			</Flex>
			<SplashBottom />
		</Flex>
	);
};
